import Vue from 'vue'
import Router from 'vue-router'
import Clock from './views/clockAppDesign.vue'
import ClockCreate from './views/allClock.vue'
import bubbleClockDesign from './views/bubbleClockDesign.vue'
import barClockDesign from './views/barClockDesign.vue'
import nyanClock from './views/nyanClockDesign.vue'

import textCount from './views/text-count.vue'
import timeCounter from './views/timeCounter.vue'
import ytComment from './views/ytComment.vue'
import toolMain from './views/toolMain.vue'
import rulesOfUse from './views/rulesOfUse.vue'
import discordroom from './views/discord-room.vue'
import timer from './views/simpleTimer.vue'
import news from './views/news.vue'
import counter from './views/counter.vue'
import counterDesign from './views/CounterDesign.vue'
import counterControl from './views/CounterControl.vue'
import simpleTimerDesign from './views/simpleTimerDesign.vue'
import simpleTimerControl from './views/simpleTimerControl.vue'
import roulette from './views/roulette.vue'

import premium from './views/premium/premiumMain.vue'
import premiumNyan from './views/premium/premium-nyan.vue'
import premiumFukidashi from './views/premium/premium-fukidashi.vue'

import nyan2 from './views/premium/premium-nyan2.vue'
import heart from './views/premium/premium-heart.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: '/tool/',
  routes: [
    {
      path: '/',
      name: 'home',
      component: toolMain,
      meta: { title: 'はいしんツールキット|TOP', desc: 'ライブ配信活動に便利なツールキットをまとめました' }
    },
    {
      path: '/rule',
      name: 'rulesOfUse',
      component: rulesOfUse
    },
    {
      path: '/news',
      name: 'news',
      component: news
    },
    {
      path: '/ytcomment',
      name: 'ytcomment',
      component: ytComment,
      meta: { title: 'はいしんツールキット|YouTube・Twitchコメント欄', desc: 'YouTubeLIVE・Twitchのコメント欄を簡単にカスタマイズ。複数のデザインから選べます。' }
    },
    {
      path: '/timecounter',
      name: 'timecounter',
      component: timeCounter,
      meta: { title: 'はいしんツールキット|年越しカウンター', desc: '2023年までのカウントダウン。今年はあとどれくらい？' }
    },
    {
      path: '/textcount',
      name: 'textcount',
      component: textCount,
      meta: { title: 'はいしんツールキット|文字カウンター', desc: 'シンプルな文字カウンター。文字数を測りたいならこれ' }
    },
    {
      path: '/clockcreate',
      name: 'clock-create',
      component: ClockCreate,
      meta: { title: 'はいしんツールキット|配信用デジタル時計', desc: 'カスタマイズ可能な時計を複数用意。自由なコンセプトを実現できます。' }
    },
    {
      path: '/timer',
      name: 'timer',
      component: timer,
      meta: { title: 'はいしんツールキット|タイマー', desc: 'シンプルなタイマー。制限時間を測れます。' }
    },
    {
      path: '/simpletimerdesign',
      name: 'simpletimerdesign',
      component: simpleTimerDesign,
      props: route => ({
        font: route.query.font
      })
    },
    {
      path: '/simpletimercontrol',
      name: 'simpletimercontrol',
      component: simpleTimerControl
    },
    {
      path: '/counter',
      name: 'counter',
      component: counter,
      meta: { title: 'はいしんツールキット|カウンター', desc: 'シンプルなカウンター。カウントを増やせます。' }
    },
    {
      path: '/clockdesign',
      name: 'clock-design',
      component: Clock
    },
    {
      path: '/bubbleclock',
      name: 'bubbleclock',
      component: bubbleClockDesign
    },
    {
      path: '/barclock',
      name: 'barclock',
      component: barClockDesign
    },
    {
      path: '/nyanClock',
      name: 'nyanclock',
      component: nyanClock
    },
    {
      path: '/discordroom',
      name: 'discordroom',
      component: discordroom
    },
    {
      path: '/counterdesign',
      name: 'counterdesign',
      component: counterDesign,
      props: route => ({
        count: parseInt(route.query.count),
        selectedFont: route.query.font,
        backgroundShape: route.query.shape,
        backgroundColor: route.query.color,
        textColor: route.query.text
      })
    },
    {
      path: '/countercontrol',
      name: 'countercontrol',
      component: counterControl
    },
    {
      path: '/premium',
      name: 'premium',
      component: premium
    },
    {
      path: '/premium-nyan',
      name: 'premium-nyan',
      component: premiumNyan
    },
    {
      path: '/premium-fukidashi',
      name: 'premium-fukidashi',
      component: premiumFukidashi
    },
    {
      path: '/premium-heart',
      name: 'premium-heart',
      component: heart
    },
    {
      path: '/premium-nyan2',
      name: 'premium-nyan2',
      component: nyan2
    },
    {
      path: '/roulette',
      name: 'roulette',
      component: roulette
    },
  ]
})